enum AttributeValueType {
  Boolean = "BOOL",
  Url = "URL",
  Enum = "ENUM",
  RepeatedEnum = "REPEATED_ENUM"
}

export default AttributeValueType;